import {
  GetAvailableRegionsResponse,
  ProjectDetailsResponse,
  GetalignmentResponse2,
} from '../generated/index';

/**
 * The object type associated with a comment or tag.
 */
export enum TcObjectType {
  FILE = 'FILE',
  FOLDER = 'FOLDER',
  VIEW = 'VIEW',
  CLASH = 'CLASH',
  RELEASE = 'RELEASE',
  TODO = 'TODO',
  ISSUE = 'ISSUE',
}

export interface TcFileFolderItem {
  id: string;
  versionId: string;
  name: string;
  type: 'FILE' | 'FOLDER';
  rootElement: boolean;
  parentId: string;
  parentType: 'FILE' | 'FOLDER';
  createdOn?: string;
  modifiedOn?: string;
  createdBy?: string;
  modifiedBy?: string;
  size: number;
  isDeleted: boolean;
  thumbnailUrl?: string;
  md5?: string;
  revision?: number;
}

export type TcModelAlignment = Pick<
  GetalignmentResponse2,
  | 'fileId'
  | 'versionId'
  | 'locationX'
  | 'locationY'
  | 'locationZ'
  | 'axisX'
  | 'axisY'
  | 'axisZ'
  | 'refDirectionX'
  | 'refDirectionY'
  | 'refDirectionZ'
  | 'scale'
>;

export type TcRegion = GetAvailableRegionsResponse;
export type TcProject = ProjectDetailsResponse;

export enum TcErrorCodes {
  UserNotInProject = 'USER_NOT_IN_PROJECT',
  ProjectNotFound = 'PROJECT_NOT_FOUND',
  InvalidParam = 'INVALID_PARAM',
}
